module.exports = __webpack_public_path__ + "img/credit-card.e28f4114.jpg";